import { render, staticRenderFns } from "./AddSimTingboxModal.vue?vue&type=template&id=34871b3d&scoped=true"
import script from "./AddSimTingboxModal.vue?vue&type=script&lang=js"
export * from "./AddSimTingboxModal.vue?vue&type=script&lang=js"
import style0 from "./AddSimTingboxModal.vue?vue&type=style&index=0&id=34871b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34871b3d",
  null
  
)

export default component.exports